import { inject } from "@angular/core";
import { applyFeatureEnvFromUrl } from "src/app/services/feature-env/feature-env-deep-link";
import { FeatureEnvService } from "src/app/services/feature-env/feature-env.service";
import { WINDOW } from "src/app/modules/shared/components/feature-branch-banner/feature-branch-cookie.service";

/**
 * Applies a feature environment from `?features=` before the app starts.
 *
 * Must run before every other initializer: the cookie decides which pods our
 * HTTP requests reach, so applying it after Keycloak or FMS have fetched would
 * waste those calls against the wrong environment and then reload anyway.
 */
export const featureEnvInitializer = (): void => {
  applyFeatureEnvFromUrl(inject(FeatureEnvService), inject(WINDOW));
};
